import React, { useState } from 'react';
import { Row, Col, Input, Space, notification } from 'antd';
import { FilterValue, TablePaginationConfig } from 'antd/lib/table/interface';
import { DEFAULT_CURRENT_PAGE, DEFAULT_PAGE_SIZE } from 'constants/config';
import { isEmpty } from 'lodash';
import { GetOfficeRequest } from 'services/office';
import { OfficeTableWithPermission } from 'modules/office/components/OfficeList/withPermissionComponents';
import { useUpdateOfficeStatus } from 'hooks/officeHooks';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import officeapi from 'services/office';

const OfficesTab: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [filters, setFilters] = useState<GetOfficeRequest>({
    pageNo: DEFAULT_CURRENT_PAGE,
    limit: DEFAULT_PAGE_SIZE,
  });

  const { isLoading, data } = useQuery(
    ['admin-offices', id, filters],
    () => officeapi.getOffices(filters, { 'x-tenant-id': id as string }),
    { keepPreviousData: true },
  );
  const updateOfficeStatus = useUpdateOfficeStatus();

  const handlePageChange = (page: number, pageSize: number) => {
    setFilters({ ...filters, pageNo: page, limit: pageSize });
  };

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  const handleTableChange = (
    pagination: TablePaginationConfig,
    tableFilters: Record<string, FilterValue | null>,
    sorter: any,
  ) => {
    setFilters({
      ...filters,
      pageNo: DEFAULT_CURRENT_PAGE,
      orderBy: sorter?.field ? sorter?.field : undefined,
      orderType: sorter?.order === 'ascend' ? 1 : -1,
    });
  };

  const handleSearch = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e?.currentTarget?.value;
    setFilters({
      ...filters,
      pageNo: DEFAULT_CURRENT_PAGE,
      search: !isEmpty(value) ? value : undefined,
    });
  };

  const openUpdateOfficeStatusModal = (id: string, firstName: string, status: boolean) => {};

  return (
    <div>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={24} className="tableSearchBar">
          <Space align="end">
            <Input
              placeholder="Search offices..."
              size="large"
              className="searchBar"
              onChange={handleSearch}
              allowClear
            />
          </Space>
        </Col>
      </Row>
      <OfficeTableWithPermission
        data={data}
        handleTableChange={handleTableChange}
        handlePageChange={handlePageChange}
        filters={filters}
        isLoading={isLoading}
        openUpdateOfficeStatusModal={openUpdateOfficeStatusModal as any}
        setFilters={setFilters}
        disabled={false}
        editPermission={true}
        setEditPermission={() => {}}
        changeStatusPermission={true}
        setChangeStatusPermission={() => {}}
        componentPermissions={[]}
        setPermission={() => {}}
      />
    </div>
  );
};

export default OfficesTab;
